var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titleAgency'),_c('filterAgency'),_c('tableAgency',{staticClass:"px-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }